import { configureStore } from '@reduxjs/toolkit'
import timerReducer from './timerSlice'
import userReducer from './userSlice'
import teamReducer from './teamSlice'
import uiReducer from './uiSlice'
import platformReducer from './platformSlice'

// Enhanced store configuration with Redux Toolkit 2.0 features
export default configureStore({
  reducer: {
    timer: timerReducer,
    user: userReducer,
    team: teamReducer,
    ui: uiReducer,
    platform: platformReducer
  },
  // New in RTK 2.0: Enhanced middleware configuration
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // New in RTK 2.0: Better serializable check configuration
      serializableCheck: {
        // Ignore these action types for serializable checks
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
      // New in RTK 2.0: Enhanced immutable check
      immutableCheck: {
        // Ignore these paths in the state
        ignoredPaths: ['ignoredPath', 'ignoredNested.one', 'ignoredNested.two'],
      },
    }),
  // New in RTK 2.0: Enhanced dev tools configuration
  devTools: process.env.NODE_ENV !== 'production',
})
